import { theme } from '@zappyrent/hundop';
import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  vertical-align: middle;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  width: 100%;
  padding: 0.2rem 0;
`;

export const NumberInputContainer = styled.div`
  display: flex;
  vertical-align: middle;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  vertical-align: middle;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;

export const ButtonContainer = styled.button<{ padding: string }>`
  background: ${theme.colors.tenant.main};
  padding: ${props => props.padding};
  border: 0;
  border-radius: 100%;
  align-self: end;
  color: #fff;
  &:hover {
    cursor: pointer;
    background: ${theme.colors.tenant.mainAlternate};
  }
  &:disabled {
    cursor: not-allowed;
    background: ${theme.colors.cross.silverFox};
  }
`;
